import { usePracticeAccess } from '@hb/react'
import { Encounter, ENCOUNTERS, EncounterType } from '@hb/shared'
import { collection, CollectionReference, orderBy, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

export const useAssessmentExams = (
  assessmentId: string | null | undefined,
  type: EncounterType,
) => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!assessmentId) return null
    if (selectedPracticeId) {
      return query(
        collection(db, ENCOUNTERS) as CollectionReference<Encounter>,
        where('assessmentId', '==', assessmentId),
        where('practiceId', '==', selectedPracticeId),
        where('type', '==', type),
        orderBy('date', 'desc'),
      )
    }
    return query(
      collection(db, ENCOUNTERS) as CollectionReference<Encounter>,
      where('assessmentId', '==', assessmentId),
      where('type', '==', type),
      orderBy('date', 'desc'),
    )
  }, [assessmentId, type, selectedPracticeId])
  return useQuery<Encounter>(ref)
}
